<nz-header class="header" nz-row nzJustify="space-between">
  <!-- Logo and application name -->
  <div nz-col [nzMd]="{ span: 4 }" [nzLg]="{ span: 6 }">
    <div class="logo-container">
      <a href="/" nz-row nzAlign="middle" class="logo-container">
        <div *ngIf="isDevOrLocal" class="ribbon">
          <div *ngIf="environment.environmentLabel" class="ribbon-text">
            {{ environment.environmentLabel }}
          </div>
        </div>
        <img
          class="logo"
          [ngClass]="{ 'ribbon-logo': isDevOrLocal }"
          src="/assets/logo.jpg"
          alt="The LEGO Group Logo"
        />
        <h1 class="app-title hide-component-lg">EMMET</h1>
      </a>
    </div>
  </div>

  <!-- Search fields -->
  <div
    *ngIf="router.url | contains: '/data/design'"
    nz-col
    [nzXs]="{ span: 20 }"
    [nzSm]="{ span: 18 }"
    [nzMd]="{ span: 16 }"
    [nzLg]="{ span: 12 }"
    [nzXl]="{ span: 10 }"
  >
    <div nz-row nzAlign="middle">
      <em-design-lookup-search-field nz-col></em-design-lookup-search-field>
      <em-equipment-select nz-col class="equipment-selector"></em-equipment-select>
    </div>
  </div>

  <div
    nz-col
    [nzXs]="{ span: 0 }"
    [nzSm]="{ span: 2 }"
    [nzMd]="{ span: 4 }"
    [nzLg]="{ span: 6 }"
    [nzXl]="{ span: 8 }"
  >
    <div nz-row class="extra-links">
      <!-- Validations -->
      <span class="validation-spacing">
        <div nz-col class="hide-component-xs">
          <em-validation></em-validation>
        </div>
      </span>

      <!-- extra links -->
      <ul
        nz-col
        class="header-menu hide-component-lg"
        *ngIf="role$ | async as role"
        nz-menu
        nzMode="horizontal"
      >
        <li [nzTitle]="dataTitleTpl" nzIcon="line-chart" nz-submenu>
          <ul>
            <li
              nz-menu-item
              [routerLink]="designUrl"
              [queryParams]="queryParams"
              routerLinkActive="ant-menu-item-selected"
            >
              Design lookup
            </li>
            <li nz-menu-item routerLink="/data/worklist" routerLinkActive="ant-menu-item-selected">
              Worklist
            </li>
          </ul>
        </li>
        <ng-template #dataTitleTpl>
          <span class="em-screen-large">Data</span>
        </ng-template>
        <li nz-submenu [nzTitle]="urlTitleTpl" nzIcon="link" *ngIf="urls$ | async as data">
          <ul>
            <li
              nz-menu-item
              *ngFor="let urlObj of data | roleLinks: role | sort: 'label'; trackBy: trackByRef"
            >
              <a [href]="urlObj.url" target="_blank">{{ urlObj.label }}</a>
            </li>
          </ul>
        </li>
        <ng-template #urlTitleTpl>
          <span class="em-screen-large">URLs</span>
        </ng-template>
      </ul>

      <!-- role selection -->
      <div nz-col class="hide-component-lg">
        <em-profile-dropdown></em-profile-dropdown>
      </div>
    </div>
  </div>
</nz-header>
